new Swiper("#swiper-btn", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  loop: true,
  direction: "vertical",
});
// 购买按钮
new Swiper(".swiper-shop-btn", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  loop: true,
});
console.log(window.options_with_values)

new Swiper("#swiper1", {
  // slidesPerView: 3,
  // slidesPerGroup: 3,
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  loop: true,
  spaceBetween: 50,
});

let swiper2 = new Swiper("#swiper2", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  spaceBetween: 50,
});
new Swiper("#swiper3", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  loop: true,

  spaceBetween: 50,
});
new Swiper("#swiper4", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  loop: true,
  navigation: {
    nextEl: ".swiper-btn-next",
    prevEl: ".swiper-btn-prev",
  },
  spaceBetween: 120,
});

let prods = window.product;
function getCur() {
  let color = $("#sp-color div.active").attr("data-val");
  return prods.filter((item) => item.option1 == color)[0];
}
function changePrice() {
  let num = $("#calcNumber").val();
  let price = ((getCur().price * num) / 100).toFixed(2);
  let compare = ((getCur().compare_at_price * num) / 100).toFixed(2);
  $("#sp_price1").html(price);
  $("#sp_price2").html(compare);
  let off_font =
    100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100);
  $(".price-group .sp-off").html(off_font + "% OFF");
}

$(".buyNow").click(function () {
  let num = $("#calcNumber").val();
  window.location.href = "/cart/" + getCur().id + ":" + num;
});

$(".reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
    changePrice();
  }
  // $("#sp_price1").html(calcTotal(price1, input.value));
  // $("#sp_price2").html(calcTotal(price2, input.value));
});
$(".add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
  changePrice();
  // $("#sp_price1").html(calcTotal(price1, input.value));
  // $("#sp_price2").html(calcTotal(price2, input.value));
});
let spImgList = [
  "https://cdn.shopify.com/s/files/1/0866/7149/1369/files/202407031-p2.png",
  "https://cdn.shopify.com/s/files/1/0866/7149/1369/files/202407031-p1.png",
];

$(function () {
  $(".option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    // style选项
    changePrice();
    let colorOptions = $("#sp-color .option.active").index();
    let sp_img = $(".product-part .p-img")[0];

    if (colorOptions == 0) {
      sp_img.src = spImgList[0];
    } else {
      sp_img.src = spImgList[1];
    }
  });

  // 购物车加购动效
  $(".cart-btn").click(function () {
    $(this).children("img").addClass("on");
    $(".sp-header-top .sp-cart .num").show();
    setTimeout(function () {
      $(".cart-btn").children("img").removeClass("on");
    }, 500);
    $(".sp-header-top .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-header-top .sp-cart").removeClass("on");
    }, 500);
  });

  // 处理加入购物车事件
  // function handleAddToCart(num) {
  //   if (num > 0) {
  //     $("#cardNum").html(num).show();
  //     $(".sp-top-btn").addClass("sp-high");

  //     $(".sp-header-top .sp-cart").addClass("on");
  //   } else {
  //     $("#cardNum").html(0).hide();

  //     $(".sp-header-top .sp-cart").removeClass("on");
  //     $(".sp-top-btn").removeClass("sp-high");
  //   }
  // }
  // handleAddToCart(window.cartCount);
  $(".cart-btn").click(function () {
    var data = {
      id: getCur().id,
      quantity: $("#calcNumber").val(),
    };

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $(".sp-cart .num").html(result.item_count);
        });
      },
      dataType: "json",
    });

    // initNum = initNum + 1;
    // $("#calcNumber").val(1);
    // $("#cardNum").html(initNum);
    var img = $(".product-part .p-img");
    var flyer = img[0].cloneNode(true);
    flyer.classList.add("sp_clone");
    $(".product-part").append(flyer);
    $(".sp_clone").css({
      width: img[0].width,
      height: 816,
      background: "#e7e9ef",
      position: "fixed",
      top: img[0].offsetTop,
      left: img.offset().left,
      "z-index": "99",
    });
    let finish = $(".sp-cart");
    $(".sp_clone").animate(
      {
        // top: finish[0].offsetTop,
        top: finish[0].offsetTop + $(".sp-nav-top").height(),
        left: finish[0].offsetLeft + finish.width() / 2,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      500,
      "linear",
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach();
          }
        );
      }
    );
  });
  // let initNum = 0;
  // $(".product-part .cart-btn").click(function () {
  //   initNum = initNum + 1;
  //   $("#calcNumber").val(1);
  //   $("#cardNum").html(initNum);
  //   var img = $(".product-part .p-img");
  //   var flyer = img[0].cloneNode(true);
  //   flyer.classList.add("sp_clone");
  //   $(".product-part").append(flyer);
  //   $(".sp_clone").css({
  //     width: img[0].width,
  //     height: img[0].height,
  //     background: "#e7e9ef",
  //     position: "fixed",
  //     top: img[0].offsetTop,
  //     left: img.offset().left,
  //     "z-index": "99",
  //   });
  //   let finish = $(".sp-cart");
  //   $(".sp_clone").animate(
  //     {
  //       // top: finish[0].offsetTop,
  //       top: finish[0].offsetTop + $(".sp-nav-top").height(),
  //       left: finish[0].offsetLeft + finish.width() / 2,
  //       width: 50, // 结束时的大小，根据需要调整
  //       height: 50, // 结束时的大小，根据需要调整
  //       opacity: 0.4,
  //     },
  //     500,
  //     "linear",
  //     function () {
  //       $(this).animate(
  //         {
  //           width: 0,
  //           height: 0,
  //           opacity: 0,
  //         },
  //         0,
  //         function () {
  //           $(this).detach();
  //         }
  //       );
  //     }
  //   );
  // });
});

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }
  //data- lazy-load

  let banner1List3 = [
    "https://cdn.shopify.com/s/files/1/0866/7149/1369/files/202407031-b1.png",
    "https://cdn.shopify.com/s/files/1/0866/7149/1369/files/202407031-b2.png",
    "https://cdn.shopify.com/s/files/1/0866/7149/1369/files/202407031-b3.png",
    "https://cdn.shopify.com/s/files/1/0866/7149/1369/files/202407031-b4.png",
    "https://cdn.shopify.com/s/files/1/0866/7149/1369/files/202407031-img5-2.png",
    "https://cdn.shopify.com/s/files/1/0866/7149/1369/files/202407031-img9-p.png",
    "https://cdn.shopify.com/s/files/1/0866/7149/1369/files/202407031-img8-1.png",
    "https://cdn.shopify.com/s/files/1/0866/7149/1369/files/202407031-img8-2.png",
    "https://cdn.shopify.com/s/files/1/0866/7149/1369/files/202407031-img8-3.png",
    "https://cdn.shopify.com/s/files/1/0866/7149/1369/files/202407031-img9-p.png",
    "https://cdn.shopify.com/s/files/1/0866/7149/1369/files/202407031-img9-p2.png",
  ];

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);

    preloadImages(banner1List3);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            297 * $("div#root").css("zoom") +
            10,
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();
